import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Get fuzzy similarity threshold from environment variable
 * @returns Similarity threshold value between 0 and 1 (default: 0.3)
 */
export function getFuzzySimilarityThreshold(): number {
  const envValue = process.env.FUZZY_SIMILARITY_THRESHOLD;
  
  if (!envValue) {
    return 0.3; // Default value
  }
  
  const parsed = parseFloat(envValue);
  
  if (!isValidSimilarityThreshold(parsed)) {
    console.warn(
      `Invalid FUZZY_SIMILARITY_THRESHOLD value: ${envValue}. Using default 0.3`
    );
    return 0.3;
  }
  
  return parsed;
}

/**
 * Validate that a similarity threshold is within valid range
 * @param value - The threshold value to validate
 * @returns True if valid (0 <= value <= 1), false otherwise
 */
export function isValidSimilarityThreshold(value: number): boolean {
  return !isNaN(value) && value >= 0 && value <= 1;
}
